import { PHONE_NUMBER } from '@/constants/Common'
import { LocaleEvent } from '../en/event'

const event: LocaleEvent = {
  events: '活動',
  showUnclaimedAccountsDesc: '無法選擇的帳號是未認領或已受邀的。受影響的玩家必須註冊帳號才能被選擇',
  eventsNearMe: '我附近的比賽',
  myEvents: '我的比賽',
  explore: '探索',
  eventStatus: '比賽現狀',
  addABracket: '添加項目',
  editEvent: '編輯比賽',
  endEvent: '結束比賽',
  addAnAnnouncement: '添加公告',
  submitPayment: '提交付款',
  register: '注册',
  registrationClosed: '注册已結束',
  registered: '已注册',
  aboutTheEvent: '關於比賽',
  announcements: '公告',
  noMoreAnnouncements: '暫無新公告',
  eventRegistration: '比賽注册',
  clubMembership: '俱樂部會員',
  clubMembershipQuestion: '你是主辦俱樂部的成員嗎？',
  contactDetails: '聯繫方式',
  selectYourBrackets: '選擇您的項目',
  competitionDates: '比賽日期',
  invitedPlayer: '受邀選手',
  invitedPlayerTooltip:
    '您的合作夥伴已邀請您參加本次活動。若要接受或拒絕此邀請，請前往球員主頁的「我的比賽項目」部分。',
  ineligibleBracket: '不合格項目',
  registrationFull: '注册已滿',
  registerForWaitlist: '登記候補名單',
  totalPaymentDue: '應付款總額（1個比賽）',
  inviteSent: '邀請已發送',
  offers: '提議',
  eventPolicies: '比賽政策',
  iAgreeText: '我已經閱讀並同意',
  healthAndSafetyPolicy: '健康和安全政策',
  liabilityPolicy: '責任政策',
  registeredSuccessfully: '您已經付款並成功注册。',
  registrationComplete: '注册完成',
  registrationCompleteText: '您的注册已完成。 您可以從您的賽事頁面編輯您的注册詳細資訊，該頁面可通過主頁訪問。',
  continueToPayment: '繼續付款',
  addPhoneNumber: '添加手機號碼',
  editPhoneNumber: '編輯手機號碼',
  bracketDetails: '項目詳情',
  players: '選手',
  teams: '隊伍',
  matches: '一些比賽',
  partnerConfirmed: '搭檔已確認',
  noPartnerSelected: '未選擇搭檔',
  partnerPending: '搭檔待定',
  viewDraws: '查看圖表',
  seedMatches: '自動生成比賽',
  editBracket: '編輯此項目',
  endBracket: '結束次項目',
  endBracketModalDesc: '一旦您選擇將此比賽单项標記為已完成，您將無法再對其進行更改。',
  withdraw: '退出',
  editPartner: '編輯搭檔',
  removePartner: '删除搭檔',
  removePartnerFirstDesc: '你確定要拒絕嗎',
  removePartnerSendDesc: '邀請參加此比賽？',
  addPartner: '添加搭檔',
  reopenBracket: '重開此項目',
  confirmWithdrawFromBracket: '您確定要從次項目中退出麼？',
  contactTheEventOrganizer: '如果您計畫申請退款，請在退出前聯系賽事組織者。',
  toRegisterFor: '注册',
  answerCompleteThePrecess: '回答以下詳細資訊以完成申請或處理',
  declineInvite: '拒絕邀請',
  declineInviteFirstDesc: '你確定要拒絕嗎',
  declineInviteSecondDesc: '邀請參加此比賽？',
  exitTheQueue: '退出隊列',
  exitTheQueueDesc:
    '如果您已經找到了下一場比賽的場地，請退出線上等候隊列。 一旦你選擇退出等候隊列，你必須親自到球場等候並確保球場是可用的',
  WL: '贏/輸',
  pointDiff: '分數差异',
  waitlisted: '候補名單',
  switchBracket: '調換項目',
  switchBrackets: '調換多個項目',
  switch: '調換',
  addParticipant: '添加參與者',
  switchBracketsConfirmation: '您確定要為所選團隊調換比賽項目嗎？',
  withdrawPlayer: '撤銷選手',
  confirmWithdrawPlayerFirstText: '您確定要删除嗎',
  confirmWithdrawPlayerSecondText: '從這個項目？',
  withdrawRefund: '撤銷/退款',
  addABracketParticipant: '添加次項目參與者',
  selectAPlayer: '從下麵的清單中選擇一個選手',
  memberOfHostClub: '選手是賽事主辦方俱樂部的成員嗎？',
  selectBracketsToSwitch: '選擇要調換的項目',
  confirmTeam: '確認小組團隊',
  editTeam: '編輯小組團隊',
  splitTeam: '折開小組團隊',
  replace: '代替',
  addAPartner: '添加搭檔',
  addAPartnerDesc:
    '如果您的搭檔已經是DUPR用戶，您可以通過蒐索此目錄將他們添加到您的組隊中。 如果您的搭檔沒有在DUPR注册，您可以通過電子郵件邀請他們加入您的組隊',
  teamConfirmed: '團隊確認',
  teamPending: '團隊待定',
  replaceTeamDesc:
    '您可以將此已注册團隊替換為此組別的任何其他等待清單中的團隊。 一旦確認要替換，將自動在初始項目和目標項目中重新生成匹配，並且是從下麵提到的團隊中選擇。',
  confirmEditTeam: '您確定要編輯團隊嗎？',
  confirmThisTeams: '您要確認此團隊嗎？',
  createTeam: '創建團隊',
  playersDifferentGenders: '選手必須是不同的性別',
  unmatchedTeams: '未匹配到的隊伍',
  pleaseSelectAnyTwoPlayers: '請從清單中選擇任意兩名選手組隊',
  youSelectedTwoPlayersSameGender:
    '您選擇了兩位相同性別的選手。 因為這是一個混合組別，所以所有隊伍必須包含一名男性和一名女性。',
  thisTeamCannotCreated: '無法創建此團隊，因為',
  and: '並且',
  isOnTheWaitlist: '在候選名單上。 請從非候補選手中創建一個團隊。',
  afterYouConfirm: '確認此選擇後，這些選手將被移至“團隊”選項',
  forfeit: '弃賽',
  bye: '再見',
  forfeitMatch: '弃賽',
  forfeitMatchDesc: '請選擇放弃比賽的隊伍。 你選擇的隊伍將被認為輸了這場比賽',
  teamA: 'A隊',
  teamB: 'B隊',
  markAsForfeit: '標記為棄權',
  youCanAddScores: '您可以在這些日期之間添加分數',
  titleSubmitScoreModal: '提交所有比賽的分數',
  scoreWarningMessage:
    '您必須完成比賽，並立即提交比賽中所有場次的分數。 如果您計畫提交這場比賽中其他場次的分數，請返回。',
  editingScoresTitle: '編輯已結束比賽的分數',
  editingScoresFirstDesc: '您正在編輯現時已結束比賽的分數。 這項賽事的排名和未完成的比賽不會受影響',
  editingScoresSecondDesc: ' You will loose the integrity of data in Diagram and standings of this event. ',
  stillContinue: '您還想繼續嗎？',
  submitScores: '提交分數',
  submittingScoresTitle: '提交這些新分數將影響已經安排設定的比賽',
  submittingScoresFirstDesc: '您選擇了新的獲勝者，下一輪的一些比賽將重新安排。',
  editScores: '編輯分數',
  addScores: '添加分數',
  deleteBracketMatchDesc: '如果您删除此比賽，您將不得不重新輸入分數，這會影響您的評分。',
  validateMatch: '驗證比賽',
  validate: '驗證',
  substitutes: '替補',
  selectParticipant: '從下麵的清單中選擇一個參與者',
  totalAmountPaid: '支付總額',
  showDetail: '顯示詳細數據',
  playerStatus: '選手狀態',
  paymentStatus: '付款狀態',
  amountPaid: '支出金額',
  amountRefunded: '退款金額',
  bracketName: '項目名稱',
  pricing: '價格',
  pricingDesc:
    '選手必須支付比賽報名費和每個組別的費用才能參加比賽。 根據您是否是主辦俱樂部的成員，比賽定價也可能有所不同。',
  eventEntryFee: '比賽報名費',
  bracketPrice: '比賽單項費',
  importantDates: '重要日期',
  importantDatesDesc:
    '選手必須支付比賽報名費和每個組別的費用才能參加比賽。 根據您是否是主辦俱樂部的成員，比賽定價也可能有所不同。',
  registrationDates: '注册日期',
  registrationLimit: '注册限制',
  numberTeamsPermitted: '允許的團隊數量',
  waitlistAllowance: '等候名單津貼',
  allowedWaitlist: '允許加入等候名單的隊伍',
  bracketType: '單項類型',
  roundRobin: '小組循環賽',
  roundRobinDesc:
    '小組迴圈錦標賽是一種每個參賽者依次與所有其他參賽者相遇的迴圈賽制。 循環賽不同於淘汰賽，淘汰賽的參與者在輸了一定次數後就會被淘汰',
  waterfall: '瀑布錦標賽',
  waterfallDesc:
    'The 16 team waterfall tournament format ensures that each team plays exactly 4 matches. The bracket is labeled with the 8 directions on a compass(North, South, East, West, Northeast, Northwest, Southeast, and Southwest). For every match, each team plays against a team with the exact same sequence of wins and losses.',
  flexLeague: '聯盟賽',
  flexLeagueDesc:
    'DUPR Flex聯賽類似於小組循環賽是每個參賽者依次與所有其他參賽者相遇的比賽。 這種賽制適合選手在有充裕的時間下組織的比賽，因為這種賽制通常會持續很長時間',
  numberCourts: '球場數量',
  playerGroup: '賽事選手群',
  playerRules: '選手規則',
  skillLevel: '科技程度',
  ageGroup: '年齡組',
  menDoubles: '選手將兩人一組進行比賽。 每隊必須由兩名男性隊員組成。',
  womenDoubles: '選手將兩人一組進行比賽。 每隊必須由2名女隊員組成。',
  mixedDoubles: '選手將兩人一組進行比賽。 每個隊必須由一名女隊員和一名男隊員組成。',
  openDoubles: '選手將兩人一組進行比賽。 球員可以是任何性別的組合',
  acceptPartner: '接受搭檔',
  leagueConsentTitle: '您的聯系資訊將被共亯',
  leagueConsentDesc:
    '一旦您注册了這場比賽，您的電子郵件和電話號碼將只對注册此比賽的其他選手可見。 這使得選手可以互相聯系比賽日程',
  noQualifyingBrackets: '沒有限定項目',
  noQualifyingBracketsTitle: '根據您的DUPR評分、年齡和性別資料，您不符合參加本次比賽中的任何公開項目',
  pleaseContactEventAdministrator: '請通過以下管道聯系賽事組織者',
  pleaseContactText: '如果您認為這是個錯誤。',
  step1: '步驟1:請選擇一個選項並繼續',
  refundOnly: '僅退款',
  withdrawAndRefund: '撤銷和退款',
  step2: '第二步',
  event: '比賽',
  bracketsOf: '比賽項目',
  total: '總數',
  paymentPending: '付款待定',
  freeEvent: '免費賽事',
  fullyRefundedEvent: '全額退款賽事',
  partiallyRefundedEvent: '部分退款賽事',
  fullyRefunded: '全額退款',
  splitTeamFirst: '首先折開小組團隊',
  freeBracket: '免費項目',
  partiallyRefunded: '部分退款',
  viewQualifyingPartners: '查看合格的搭檔',
  viewQualifyingPartnersDesc: '該DUPR用戶列表將僅顯示根據其聲明的評級、年齡和性別符合此賽事單項要求的潜在搭檔',
  joiningWaitlist: '您加入了等候清單',
  joiningWaitlistDesc: '您已選擇加入至少一個比賽單項的等候名單。 如果你被移出此候選名單，賽事管理人員會及時通知您',
  fromSelectedBrackets: '從選定的賽事項目中？',
  sureRefundATotalAmount: '您確定要退還總額是',
  sureRemove: '您確定要删除嗎',
  seedMatchesDesc: '按開始比賽來組織隊伍',
  createMatches: '創建比賽',
  seeds: '創建',
  reseedMatches: '重新創建比賽',
  bracketCreated: '比賽項目已建立。',
  endEventModalDesc: '一旦您選擇將此事件標記為已完成，您將無法再對此事件進行變更。該事件將永久標記為非活動狀態。',
  endEventTitleModal: '您確定要結束此活動嗎？',
  reopenBracketDesc: '重新開啟此分組後，您將能夠新增分數並編輯訊息，直到比賽項目結束',
  addABracketParticipantDesc: '無人認領或未被邀請的帳號將無法被安排比賽，受影響的選手必須注册一個帳號才能被安排比賽',
  youLikeToCreateTeam: '您確定要創建此團隊嗎？',
  submittingScoresSecondDesc:
    '如果球員已經在場上並且您不想編輯當前的比賽，請點擊「返回」。賽事結束後，您可以隨時編輯個人比賽的分數。如果您想繼續進行新的比賽，請提交分數。',
  validateMatchDesc: `您確定要驗證這些分數嗎？ 如果是這樣，比賽結束並且選手等級將會更新。 如果這些分數不正確，請聯系活動負責人或發短信 ${PHONE_NUMBER} 告知正確的分數`,
  endBracketModalTitle: '您確定要結束此比賽項目嗎？',
  moveToUnmatchedTab:
    '該球員退出比賽后，他們將被移至（未參賽選手）標籤。從那裡，您可以將該球員添加到另一個團隊或將他們從活動中完全撤回。',
}

export default event
